import { dataHook as categoriesListDataHook } from '../../common/components/CategoriesList';
import { dataHook as articleContainerDataHook } from '../../help-center/components/ArticleContainer/ArticleContainer';
import { dataHook as categoryArticlesDataHook } from '../../pages/Category/CategoryArticles';
import { PresentedState } from './helpCenter';
import { Bi1121EventDataRaw } from './types';

function getContainerDataHook(presentedState: PresentedState) {
  switch (presentedState) {
    case PresentedState.AllHelpTopics:
    case PresentedState.SubCategoriesList:
      return categoriesListDataHook;
    case PresentedState.SolutionList:
      return categoryArticlesDataHook;
    case PresentedState.SingleArticle:
      return articleContainerDataHook;
    default:
      return null;
  }
}

export function getMaxScrollData(
  presentedState: PresentedState,
): Pick<Bi1121EventDataRaw, 'max_scroll' | 'max_scroll_at_first_position'> {
  const containerDataHook = getContainerDataHook(presentedState);
  const container =
    containerDataHook &&
    document.querySelector(`[data-hook="${containerDataHook}"]`);
  if (!container) {
    return {
      max_scroll_at_first_position: false,
    };
  }
  const { scrollTop, scrollHeight, clientHeight } = container;
  const maxScrollAtFirstPosition = clientHeight === scrollHeight;
  return {
    max_scroll_at_first_position: maxScrollAtFirstPosition,
    max_scroll: maxScrollAtFirstPosition
      ? 100
      : Math.round((scrollTop / (scrollHeight - clientHeight)) * 100),
  };
}
